import type { PluginKey } from '@tiptap/pm/state';
import type { Editor } from '@tiptap/react';

type SuggestionRange = { from: number; to: number };

/** Remove the typed trigger + filter query when a composer suggestion is cancelled. */
export const removeComposerSuggestionTrigger = (
  editor: Editor,
  range: SuggestionRange,
  char: string
): boolean => {
  const triggerText = editor.state.doc.textBetween(range.from, range.to, '');
  if (!triggerText.startsWith(char)) return false;
  editor.chain().focus(undefined, { scrollIntoView: false }).deleteRange(range).run();
  return true;
};

export const exitComposerSuggestion = (
  editor: Editor,
  pluginKey: PluginKey,
  range: SuggestionRange,
  char: string
): void => {
  removeComposerSuggestionTrigger(editor, range, char);
  const tr = editor.state.tr.setMeta(pluginKey, { exit: true });
  editor.view.dispatch(tr);
};
